import { FC } from 'react';
import { Menu, MenuProps } from '@mui/material';

import useMenu from './useMenu';

export type MenuContentProps = Omit<MenuProps, 'anchorEl' | 'onClose' | 'open'>;

export const MenuContent: FC<MenuContentProps> = ({
  children,
  disablePortal,
  MenuListProps,
  elevation = 8,
  ...rest
}) => {
  const { anchorEl, open, onClose } = useMenu();

  return (
    <Menu
      anchorEl={anchorEl}
      disablePortal={disablePortal}
      MenuListProps={{
        ...MenuListProps,
        autoFocusItem: MenuListProps?.autoFocusItem || !!anchorEl,
        sx: { ...MenuListProps?.sx, minWidth: anchorEl && anchorEl.offsetWidth },
      }}
      onClick={e => e.stopPropagation()}
      onClose={(e: Event, reason) => {
        if (reason === 'backdropClick') e.stopPropagation();
        onClose();
      }}
      open={open}
      slotProps={{
        paper: { variant: 'elevation', elevation },
      }}
      {...rest}
    >
      {children}
    </Menu>
  );
};
